<p-toast position="top-center no-print"></p-toast>
<div class="surface-section px-2 sm:px-2 md:px-4 lg:px-4 py-2 sm:py-2 md:py-5 lg:py-5 flex flex-wrap bg-primary p-0"
     style="border-bottom-left-radius: 30px;border-bottom-right-radius: 30px">
  <div class="w-full md:w-6 hidden sm:hidden md:block mt-4">
    <span class="inline-flex align-items-center text-900 text-lg sm:text-lg md:text-2xl lg:text-2xl font-medium mb-3 cursor-pointer font-bold">Crea un nuovo account</span>
  </div>
  <div class="w-full md:w-6 flex flex-column md:flex-row md:align-items-center md:justify-content-end mt-1 sm:mt-1 md:mt-0 lg:mt-0">
    <img [src]="'assets/img/' + baseImagePath +'/logo.png'" alt="Image" class="imgLogoHeader">
  </div>
  <div class="w-full md:w-6 block sm:block md:hidden mt-5">
    <span class="inline-flex align-items-center text-900 text-lg sm:text-lg md:text-2xl lg:text-2xl font-medium mb-3 cursor-pointer font-bold">Crea un nuovo account</span>
  </div>
</div>
<form id="registrationForm" name="registrationForm" #registrationForm="ngForm" autocomplete="off">
  <div class="w-full block sm:block md:flex lg:flex mt-5 pl-1 sm:pl-1 md:pl-8 pr-1 sm:pr-1 md:pr-8 lg:pr-8">
    <div class="col-12 sm:col-12 md:col-8 lg:col-8 block">
      <div class="w-full field flex">
        <label class="mt-2 labelWidth">Nome</label>
        <div class="w-full block">
          <input id="name"
                 type="text"
                 pInputText
                 class="w-full"
                 name="name"
                 [(ngModel)]="registrationModel.Nome"
                 #name='ngModel'
                 required>
          <div *ngIf="name.invalid && (name.dirty || name.touched || submittedPage)"
               class="alert mt-2">

            <div *ngIf="name.errors?.['required']">
              Campo obbligatorio.
            </div>
          </div>
        </div>
      </div>
      <div class="w-full field flex">
        <label class="mt-2 labelWidth">Cognome</label>
        <div class="w-full block">
          <input id="surname"
                 type="text"
                 pInputText
                 class="w-full"
                 name="surname"
                 [(ngModel)]="registrationModel.Cognome"
                 #surname='ngModel'
                 required>
          <div *ngIf="surname.invalid && (surname.dirty || surname.touched || submittedPage)"
               class="alert mt-2">

            <div *ngIf="surname.errors?.['required']">
              Campo obbligatorio.
            </div>
          </div>
        </div>

      </div>
      <div class="w-full field flex">
        <label class="mt-2 labelWidth">Data di Nascita</label>
        <div class="w-full block">
          <p-calendar [showIcon]="true"
                      inputId="icon"
                      styleClass="w-full"
                      appendTo="body"
                      class="w-full"
                      name="birthDate"
                      [(ngModel)]="registrationModel.DataNascita"
                      #birthDate='ngModel'
                      dateFormat="{{displayDateFormat}}"
                      yearRange="{{yearRange}}"
                      [firstDayOfWeek]="1"
                      [required]="true"></p-calendar>
          <div *ngIf="birthDate.invalid && (birthDate.dirty || birthDate.touched || submittedPage)"
               class="alert mt-2">

            <div *ngIf="birthDate.errors?.['required']">
              Campo obbligatorio.
            </div>
          </div>
        </div>
      </div>
      <div class="w-full field flex">
        <label class="mt-2 labelWidth">Luogo di nascita</label>
        <div class="w-full block">
          <p-autoComplete [(ngModel)]="comuneNascitaSelezionato"
                          [suggestions]="comuniList"
                          field="ComuneDescrizione"
                          (completeMethod)="getComuniAutoComplete($event)"
                          styleClass="w-full"
                          name="birthPlace"
                          #birthPlace='ngModel'
                          [required]="true">
            <ng-template let-comune pTemplate="item">
              <div class="person-item">
                <div>{{comune.ComuneDescrizione}}</div>
              </div>
            </ng-template>
          </p-autoComplete>
          <div *ngIf="birthPlace.invalid && (birthPlace.dirty || birthPlace.touched || submittedPage)"
               class="alert mt-2">

            <div *ngIf="birthPlace.errors?.['required']">
              Campo obbligatorio.
            </div>
          </div>
        </div>
      </div>
      <div class="w-full field flex">
        <label class="mt-2 labelWidth">Codice fiscale</label>
        <div class="w-full block">
          <input id="fiscalCode"
                 type="text"
                 pInputText
                 class="w-full"
                 name="fiscalCode"
                 [(ngModel)]="registrationModel.CodiceFiscale"
                 #fiscalCode='ngModel'
                 (ngModelChange)="registrationModel.CodiceFiscale = $event.toUpperCase()"
                 required>

          <div *ngIf="fiscalCode.invalid && (fiscalCode.dirty || fiscalCode.touched || submittedPage)"
               class="alert mt-2">

            <div *ngIf="fiscalCode.errors?.['required']">
              Campo obbligatorio.
            </div>

            <div *ngIf="fiscalCode.errors?.['pattern']">
             Codice fiscale non valido
            </div>
          </div>
        </div>
      </div>

      <div class="w-full field flex">
        <label class="mt-2 labelWidth pr-2">Sesso</label>
        <div class="w-full block">
          <select class="w-full" pInputText style="appearance: auto"
                  [(ngModel)]="registrationModel.Sesso" id="sesso" name="sesso" #sesso='ngModel'
                  required>
            <option [ngValue]="'M'">MASCHIO</option>
            <option [ngValue]="'F'">FEMMINA</option>
            <option [ngValue]="null"></option>
          </select>

          <div *ngIf="sesso.invalid && (sesso.dirty || sesso.touched || submittedPage)"
               class="alert mt-2">

            <div *ngIf="sesso.errors?.['required']">
              Campo obbligatorio.
            </div>
            <div *ngIf="sesso.errors?.['pattern']">
              Email non valida
            </div>
          </div>
        </div>
      </div>
      <div class="w-full field flex">
        <label class="mt-2 labelWidth">Comune di residenza </label>
        <div class="w-full block">
          <p-autoComplete [(ngModel)]="comuneResidenzaSelezionato"
                          [suggestions]="comuniList"
                          field="ComuneDescrizione"
                          (completeMethod)="getComuniAutoComplete($event)"
                          styleClass="w-full"
                          name="comuneResidenza"
                          #comuneResidenza='ngModel'
                          [required]="true">
            <ng-template let-comune pTemplate="item">
              <div class="person-item">
                <div>{{comune.ComuneDescrizione}}</div>
              </div>
            </ng-template>
          </p-autoComplete>
          <div *ngIf="comuneResidenza.invalid && (comuneResidenza.dirty || comuneResidenza.touched || submittedPage)"
               class="alert mt-2">

            <div class="errorMsg" *ngIf="comuneResidenza.errors?.['required']">
              Campo obbligatorio.
            </div>
          </div>
        </div>
      </div>
      <div class="w-full field flex">
        <label class="mt-2 labelWidth">Mansione</label>
        <div class="w-full block">
          <p-autoComplete [(ngModel)]="lstLavoroDesiderato"
                          [suggestions]="taskList"
                          field="MansioneDesc"
                          (completeMethod)="getMansioni($event)"
                          styleClass="w-full"
                          class="w-full"
                          appendTo="body"
                          [dropdown]="true"
                          name="task"
                          [multiple]="true">
            <ng-template let-task pTemplate="item">
              <div class="person-item">
                <div>{{task.MansioneDesc}}</div>
              </div>
            </ng-template>
          </p-autoComplete>
        </div>
      </div>
      <div class="w-full flex">
        <label class="mt-2 labelWidth">Numero di cellulare </label>
        <div class="w-full block">
          <input id="mobilePhone"
                 type="text"
                 pInputText
                 class="w-full"
                 name="mobilePhone"
                 [(ngModel)]="registrationModel.Cellulare"
                 #mobilePhone='ngModel'
                 required>
          <div *ngIf="mobilePhone.invalid && (mobilePhone.dirty || mobilePhone.touched || submittedPage)"
               class="alert mt-2">

            <div class="errorMsg" *ngIf="mobilePhone.errors?.['required']">
              Campo obbligatorio.
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12 sm:col-12 md:col-4 lg:col-4 block">
<!--      <div style="height: 125pt;border-radius: 30px" class="border-2 ml-0 sm:ml-0 md:ml-5 lg:ml-5 border-dashed surface-border uploadBackgroungColor block">-->
<!--        <div class="w-full flex justify-content-center align-content-center">-->
<!--          <p-fileUpload mode="basic"-->
<!--                        [chooseIcon]="'pi-camera'"-->
<!--                        name="demo[]"-->
<!--                        url="./upload.php"-->
<!--                        accept="image/*"-->
<!--                        [maxFileSize]="1000000"-->
<!--                        (onUpload)="onBasicUpload($event)"-->
<!--                        class="flex align-items-center justify-content-center"></p-fileUpload>-->
<!--        </div>-->
<!--        <div class="w-full flex justify-content-center">-->
<!--          <i class="pi pi-cloud-upload mb-1"></i>-->
<!--          <label class="ml-2 mt-2">Carica la tua immagine profilo</label>-->
<!--          <i class="pi pi-info-circle ml-2 mt-2"></i>-->
<!--        </div>-->
<!--      </div>-->
      <!-- CONTENITORE VISIVO (ex p-fileUpload) -->
      <div
        class="border-2 ml-0 sm:ml-0 md:ml-5 lg:ml-5 mt-5 border-dashed surface-border uploadBackgroungColor block cursor-pointer"
        style="height: 125pt; border-radius: 30px"
        (click)="openCvFilePicker()">

        <div class="w-full h-full flex flex-column align-items-center justify-content-center">
          <!-- ICONA -->
          <i
            class="pi"
            [ngClass]="this.cvLoaded ? 'pi-check-circle text-green-500' : 'pi-file'"
            style="font-size: 40pt; color: var(--primary)">
          </i>

          <!-- TESTO -->
          <label class="mt-2 font-medium">
            {{ this.cvLoaded ? 'CV caricato' : 'Carica il tuo curriculum vitae' }}
          </label>

          <!-- NOME FILE -->
          <small *ngIf="this.cvLoaded" class="mt-1 text-600">
            {{ this.fileCV.name }}
          </small>
        </div>
      </div>

      <!-- INPUT FILE REALE (NASCOSTO) -->
      <input
        type="file"
        #profileCv
        style="display: none"
        accept="application/pdf,.pdf"
        (change)="onBasicUpload($event)">
    </div>
  </div>
  <div class="w-full block pl-0 sm:pl-0 md:pl-8 pr-0 sm:pr-0 md:pr-8 lg:pr-8">
    <div class="col-12 block sm:block md:flex lg:flex p-0">
      <div class="col-12 sm:col-12 md:col-6 lg:col-6 field flex">
        <label class="mt-2 labelWidth pr-2">Indirizzo email</label>
        <div class="w-full block">
          <input id="email"
                 type="text"
                 pInputText
                 class="w-full"
                 name="email"
                 [(ngModel)]="registrationModel.Email"
                 #email='ngModel'
                 required>

          <div *ngIf="email.invalid && (email.dirty || email.touched || submittedPage)"
               class="alert mt-2">

            <div *ngIf="email.errors?.['required']">
              Campo obbligatorio.
            </div>
            <div *ngIf="email.errors?.['pattern']">
              Email non valida
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 sm:col-12 md:col-6 lg:col-6 field flex">
        <label class="mt-2 labelWidth">Conferma email</label>
        <div class="w-full block">
          <input id="confirmEmail"
                 type="text"
                 pInputText
                 class="w-full"
                 name="confirmEmail"
                 [(ngModel)]="registrationModel.confirmEmail"
                 #confirmEmail='ngModel'
                 required>

          <div *ngIf="confirmEmail.invalid && (confirmEmail.dirty || confirmEmail.touched || submittedPage)"
               class="alert mt-2">

            <div *ngIf="confirmEmail.errors?.['required']">
              Campo obbligatorio.
            </div>
            <div *ngIf="confirmEmail.errors?.['pattern']">
              Email non valida
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12 block sm:block md:flex lg:flex p-0">
      <div class="col-12 sm:col-12 md:col-6 lg:col-6 field flex">
        <label class="mt-2 labelWidth pr-2">Password</label>
        <div class="w-full block" lang="it">
          <p-password [styleClass]="'w-full'"
                      class="w-full"
                      [toggleMask]="true"
                      [strongLabel]="'Forte'"
                      [mediumLabel]="'Medio'"
                      [weakLabel]="'Debole'"
                      [promptLabel]="'Inserisci una Password'"
                      name="password"
                      [(ngModel)]="registrationModel.Password"
                      #password='ngModel'
                      [required]="true"></p-password>

          <div *ngIf="password.invalid && (password.dirty || password.touched || submittedPage)"
               class="alert mt-2">

            <div *ngIf="password.errors?.['required']">
              Campo obbligatorio.
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 sm:col-12 md:col-6 lg:col-6 field flex">
        <label class="mt-2 labelWidth">Conferma Password</label>
        <div class="w-full block">
          <p-password [styleClass]="'w-full'"
                      class="w-full"
                      [toggleMask]="true"
                      [strongLabel]="'Forte'"
                      [mediumLabel]="'Medio'"
                      [weakLabel]="'Debole'"
                      [promptLabel]="'Inserisci una Password'"
                      name="confirmPassword"
                      [(ngModel)]="registrationModel.confirmPassword"
                      #confirmPassword='ngModel'
                      [required]="true"></p-password>

          <div *ngIf="confirmPassword.invalid && (confirmPassword.dirty || confirmPassword.touched || submittedPage)"
               class="alert mt-2">

            <div *ngIf="confirmPassword.errors?.['required']">
              Campo obbligatorio.
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12 block">
      <label class="w-full font-bold">Regole e condizioni d'uso del servizio</label><br>
      <label class="w-full font-bold">Informative sulla privacy</label>
      <br><br>
        <div class="w-full block">
          <p-checkbox id="privacyCheck"
                      [binary]="true"
                      styleClass="mr-2"
                      name="privacyCheck"
                      [(ngModel)]="registrationModel.privacyCheck"
                      #privacyCheck='ngModel'
                      [required]="true"></p-checkbox>
              <label>Ho letto e accettato le </label><a href="/assets/Docs/CondizioniUso.pdf" target="_blank">Condizioni</a>
              <label> e le </label> <a href="/assets/Docs/PrivacyCandidati.pdf" target="_blank">normative sulla privacy</a>
          <div *ngIf="privacyCheck.invalid && submittedPage"
               class="alert mt-2">

            <div *ngIf="privacyCheck.errors?.['required']">
              Campo obbligatorio.
            </div>
          </div>
        </div>
        <br>
        <div class="w-full block">
          <p-checkbox id="invioemailCheck"
                      [binary]="true"
                      styleClass="mr-2"
                      name="invioemailCheck"
                      [(ngModel)]="registrationModel.AccettoInvioEmailFlag"
                      #privacyCheck='ngModel'
                      [required]="true"></p-checkbox>
          <label>Accetto l’invio di e-mail con offerte di lavoro</label>
        </div>
      </div>
  </div>
  <div class="w-full flex justify-content-center mt-5 mb-5">
    <div class="col-4 justify-content-center block p-0">
      <button *ngIf="mostraPulsante" pButton pRipple label="Iscriviti"  id="btnIscriviti" class="mt-4 w-full p-button-rounded" (click)="SignUp()"></button>
    </div>
  </div>
</form>
<ngx-spinner type="ball-scale-multiple"></ngx-spinner>
